import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MedicosService } from 'src/app/services/medicos.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import { FunctionsService } from 'src/app/services/functions.service';
import Swal from 'sweetalert2';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-next-appointment',
  templateUrl: './next-appointment.component.html',
  styleUrls: ['../../../../assets/css/styles.css', './next-appointment.component.css']
})
export class NextAppointmentComponent implements OnInit, OnChanges {

  @Input() data: any = {};

  usuario: any;
  _usuario: any = {};

  data_selected: any = {};
  options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

  cancel_reason: string = '';
  date: any;
  video_bool: boolean = false;

  anularConsultaForm: FormGroup;
  cancelReason: any[] = [];
  modalActual: string | null = null;

  cancelMsg1: string = '';
  cancelMsg2: string = '';

  date_consulta: Date;
  options_bool: boolean = true;
  popoverColor: string = '';

  isCanceling = false;

  constructor(
    private router: Router,
    private _medicosServices: MedicosService,
    private _schedule: ScheduleService,
    private _functions: FunctionsService,
    private fb: FormBuilder
  ) {
    this.anularConsultaForm = this.fb.group({
      paciente: [null, Validators.required],
      id_consulta: [null, Validators.required],
      motivo: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.popoverColor = '#0e0087';

    this.usuario = new EncriptacionService().getUserInfo();
    this._usuario = new EncriptacionService().getUserInfo();
    this.date = new Date().toISOString().slice(0, 10);

    this._schedule.getListarCancelReason('RESERVA')
      .then((response: any) => {
        this.cancelReason = response || [];
      })
      .catch(() => {
        this.cancelReason = [];
      });

    this.recalcularFechaConsulta();
    this.setCancelMessages();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      this.recalcularFechaConsulta();
      this.setCancelMessages();
    }
  }

  private recalcularFechaConsulta(): void {
    try {
      const fechaConsulta = this.data?.consulta?.fecha_consulta;
      const horaConsulta = this.data?.consulta?.hora;

      this.date = new Date().toISOString().slice(0, 10);

      if (fechaConsulta && horaConsulta) {
        this.date_consulta = this._functions
          .formatApptDate(new Date(fechaConsulta), horaConsulta).date;

        this.video_bool = this.date === fechaConsulta.substr(0, 10);

        this.options_bool = true;
        this.observador();
        return;
      }

      this.video_bool = false;
    } catch (error) {
      console.error('Error recalculando fecha de consulta:', error);
      this.video_bool = false;
    }
  }

  async observador() {
    while (this.options_bool && this.date_consulta) {
      const dateNow = new Date();
      this.options_bool = this.date_consulta > dateNow;
      await this.sleep(60 * 1000);
    }
  }

  sleep(ms = 0) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private toBoolean(value: any): boolean {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  isConsultaOndemand(): boolean {
    return this.toBoolean(
      this.data?.consulta?.tel_doc_app_boo_is_ondemand ?? this.data?.tel_doc_app_boo_is_ondemand
    );
  }

  isConsultaConfirmada(): boolean {
    return this.toBoolean(this.data?.confirmedFlag);
  }

  esDiaConsulta(): boolean {
    return this.video_bool;
  }

  puedeConfirmarAsistencia(): boolean {
    return this.usuario?.typ_id === 2
      && !this.toBoolean(this.data?.acompanante)
      && !this.isConsultaOndemand()
      && !this.isConsultaConfirmada();
  }

  /**
   * Muestra el botón de ingreso cuando:
   * - Es on demand, porque no requiere confirmación.
   * - Es agendamiento y la consulta ya está confirmada.
   *
   * Importante:
   * Acá NO se evalúa si puede entrar todavía.
   * Solo se decide si el botón debe aparecer.
   */
  puedeMostrarIngresoConsulta(): boolean {
  if (this.usuario?.typ_id === 1) {
    return true;
  }

  if (this.isConsultaOndemand()) {
    return true;
  }

  return this.isConsultaConfirmada();
}

  /**
   * Habilita el botón de ingreso cuando:
   * - Es on demand y ya tiene habilitado el ingreso.
   * - Es agendamiento, está confirmada y es el día de la consulta.
   *
   * Se deja también goLobbyFlag como respaldo, por si el backend ya calcula
   * una ventana horaria más específica.
   */
  puedeEntrarConsulta(): boolean {
  if (this.usuario?.typ_id === 1) {
    return true;
  }

  if (this.isConsultaOndemand()) {
    return this.toBoolean(this.data?.goLobbyFlag) || this.video_bool;
  }

  return this.isConsultaConfirmada()
    && (this.toBoolean(this.data?.goLobbyFlag) || this.esDiaConsulta());
}

  puedeMostrarSalaEspera(): boolean {
    return this.puedeMostrarIngresoConsulta();
  }

  puedeEntrarSalaEspera(): boolean {
    return this.puedeEntrarConsulta();
  }

  getAppointmentColor(): string {
  if (this.usuario?.typ_id === 1) {
    return 'default';
  }

  if (this.puedeEntrarConsulta()) {
    return 'goLobby';
  }

  if (this.puedeConfirmarAsistencia()) {
    return 'confirm';
  }

  return 'default';
}

  goLobby = () => {
    if (!this.puedeEntrarSalaEspera()) {
      return;
    }

    const url = 'salaespera/' + this.data.zoo_mee_room_id + '/' + this.data.id_consulta + '/' + this.data.med_con_id;
    this.router.navigate([url]);
  }

  goLobbyAcomp() {
    if (!this.puedeEntrarSalaEspera()) {
      return;
    }

    const url = 'salaespera-group/' + this.data.zoo_mee_room_id + '/' + this.data.id_consulta + '/' + this.data.med_con_id;
    this.router.navigate([url]);
  }

  goVideoConsultaMedico = () => {
  if (!this.puedeEntrarConsulta()) {
    return;
  }

  const url = 'videoconsulta/' + this.data.id_consulta;
  this.router.navigate([url]);
}

  confirmAppt = () => {
    this._medicosServices.postUpdateSheduleState(this.data.id_consulta)
      .then(() => {
        this.data.confirmedFlag = true;
        this.data.confirmFlag = false;

        if (this.data?.consulta) {
          this.data.consulta.tel_doc_app_boo_sta_id = 2;
        }

        this.cerrarModal();
        this.recalcularFechaConsulta();
      })
      .catch(error => {
        console.log(error);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo confirmar la asistencia. Inténtalo nuevamente.',
          confirmButtonColor: '#2BABB7'
        });
      });
  }

  confirmarCancelAppo() {
    this._schedule.cancelAppointment(this.data.id_consulta, this._usuario._id, this.cancel_reason, null, null)
      .then(() => {
        Swal.fire({
          allowOutsideClick: false,
          html:
            '<i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
            '<h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;">Su consulta ha sido anulada exitosamente</h1> <br>' +
            '<p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>',
          showConfirmButton: false,
        });

        setTimeout(() => window.location.reload(), 2000);
      })
      .catch(error => console.log(error));
  }

  detallesConsulta(data: any) {
    const url = 'detalleconsulta/' + data.med_con_id;
    this.router.navigate([url]);
  }

  modificarConsulta(data: any) {
    const url = 'modificarConsulta/' + data.med_con_id;
    this.router.navigate([url]);
  }

  mostrarModal(tipo: string) {
    if (tipo === 'confirmar') {
      this.modalActual = tipo;
      document.body.classList.add('modal-open');
      return;
    }

    Swal.fire({
      allowOutsideClick: false,
      html: `<div style="margin: 40px 0;">
              <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
              <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                Espere por favor...
              </h1>
            </div>`,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    this._schedule.getListarCancelReason('RESERVA')
      .then((response: any) => {
        this.cancelReason = response || [];

        Swal.close();

        this.setCancelMessages();

        this.modalActual = tipo;
        document.body.classList.add('modal-open');

        this.anularConsultaForm.patchValue({
          paciente: this.usuario?._id,
          id_consulta: this.data?.id_consulta
        });
      })
      .catch((error: any) => {
        console.error('Error al obtener los motivos de cancelación:', error);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar los motivos de cancelación. Inténtalo nuevamente.',
          confirmButtonColor: '#2BABB7'
        });
      });
  }

  cerrarModal() {
    this.modalActual = null;
    document.body.classList.remove('modal-open');
  }

  async anularConsulta() {
    if (this.anularConsultaForm.invalid) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'Por favor selecciona una razón antes de salir de la fila.',
        confirmButtonColor: '#2BABB7'
      });
      return;
    }

    const motivo = this.anularConsultaForm.value.motivo;
    const pacienteId = this.usuario._id;
    const idConsulta = this.data.id_consulta;

    Swal.fire({
      allowOutsideClick: false,
      html: `<div style="margin: 40px 0;">
              <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
              <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                Procesando solicitud...
              </h1>
            </div>`,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    try {
      await this._schedule.cancelAppointment(idConsulta, pacienteId, motivo, null, null);

      this.cerrarModal();

      Swal.fire({
        allowOutsideClick: false,
        html: `<i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i>
              <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; text-align: center; color: #171994;">
                Su consulta ha sido anulada exitosamente
              </h1>`,
        showConfirmButton: false
      });

      setTimeout(() => {
        Swal.close();
        this.router.navigateByUrl('/dashboard').then(() => window.location.reload());
      }, 2000);

    } catch (error) {
      console.error('Error al cancelar la espera:', error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo procesar la solicitud. Inténtalo nuevamente.',
        confirmButtonColor: '#2BABB7'
      });
    }
  }

  mostrarModalConfirmacion() {
    if (this.anularConsultaForm.invalid) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'Por favor selecciona un motivo de anulación.',
        confirmButtonColor: '#2BABB7'
      });
      return;
    }

    this.modalActual = 'confirmacionFinal';
  }

  anularConsultaConfirmada() {
    if (this.isCanceling) {
      return;
    }

    this.isCanceling = true;

    const motivo = this.anularConsultaForm.value.motivo;
    const pacienteId = this.usuario._id;
    const idConsulta = this.data.id_consulta;

    this._schedule.cancelAppointment(idConsulta, pacienteId, motivo, null, null)
      .then(() => {
        this.modalActual = null;
        document.body.classList.remove('modal-open');

        Swal.fire({
          allowOutsideClick: false,
          html: `<i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i>
               <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; text-align: center; color: #171994;">
                   Su consulta ha sido anulada exitosamente
               </h1>`,
          showConfirmButton: false
        });

        setTimeout(() => {
          Swal.close();
          this.router.navigateByUrl('/dashboard').then(() => window.location.reload());
        }, 2000);
      })
      .catch(error => {
        console.error('Error al cancelar la consulta:', error);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo procesar la anulación. Inténtalo nuevamente.',
          confirmButtonColor: '#2BABB7'
        });
      })
      .finally(() => {
        this.isCanceling = false;
      });
  }

  private setCancelMessages(): void {
    const isSnabb = this.data?.consulta?.is_snabb;
    const canRefunded = this.data?.consulta?.can_refunded;

    if (isSnabb && canRefunded) {
      this.cancelMsg1 = 'Al confirmar la anulación, se perderá la reserva de la hora y se iniciará el proceso de reembolso del pago realizado.';
      this.cancelMsg2 = 'Para más información, revisa el detalle de reembolso disponible en nuestros términos y condiciones.';
      return;
    }

    if (isSnabb && !canRefunded) {
      this.cancelMsg1 = 'Al confirmar la anulación, se perderá la reserva de la hora y no será posible el reembolso del pago realizado, ya que la cancelación se está realizando con menos de 1 hora de anticipación al inicio de la consulta.';
      this.cancelMsg2 = '';
      return;
    }

    this.cancelMsg1 = 'Al hacerlo, perderás tu reserva actual y deberás solicitar una nueva hora si deseas reagendar.';
    this.cancelMsg2 = '';
  }
}